// Human-readable request number, e.g. seq 1 -> "#000001". Empty if not assigned yet.
export const reqNo = (seq) => (seq ? `#${String(seq).padStart(6, '0')}` : '');
